import { useEffect }               from 'react';
import { groupUrl }                from 'utils/constants'
import { store }                   from 'index'
import { SET_CREATE_DATA_ONCE }    from 'actions/dataActions';
import { CREATE_DATA_SAGA }        from 'actions';
import { objType, updateInfoType } from 'types';
import { dataStateType }           from 'reducer/types';

const useSetData = (
  dataUpdateState: updateInfoType,
  contentState:    objType,
  data:            dataStateType,
  guest:           boolean
) => {
   
  useEffect(() => {

    const { 
      dataState,
      userInfo,
      createDataOnce
    } = data;

    const content = {
      bigContentArr:  contentState.bigContentArr,
      apps:           contentState.apps,
      interaction:    contentState.interaction,
      lessons:        contentState.lessons,
      puzzles:        contentState.puzzles,
      bigTeacherArr:  contentState.bigTeacherArr,
      mivdakim:       contentState.mivdakim,
      teacherLessons: contentState.teacherLessons,
    }

    const { hash } = contentState;


    if ( dataUpdateState.final ) {
        return
    }  

    // loda real data
   
    if ( 
           !groupUrl &&
           dataUpdateState.teacherContent &&
           dataUpdateState.content &&
           dataUpdateState.activity &&
           dataUpdateState.totalLikes &&
           dataUpdateState.scores &&
           !createDataOnce
         ) {
  
          console.log('about to create data')
  
          const payload = {
            content:     content,
            data:        dataState,
            hash:        hash,
            userEmail:   userInfo.userEmail,
            variant:     'real',
            guest:       guest
          }
  
          store.dispatch(SET_CREATE_DATA_ONCE());
          store.dispatch(CREATE_DATA_SAGA(payload));
    }  
  },[ dataUpdateState, contentState, data, guest])
}

export default useSetData